import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
	UnlinkSsoDialogComponent
} from '@go-modules/components/dialogs/unlink-sso-dialog/unlink-sso-dialog.component';
import { CommonModule } from '@angular/common';
import { GoMaterialModule } from '@go-modules/go-material.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule
	],
	declarations: [
		UnlinkSsoDialogComponent
	],
	exports: [
		UnlinkSsoDialogComponent
	]
})
export class UnlinkSsoDialogModule {}
